// extracted by mini-css-extract-plugin
export var base = "_2b-0";
export var updateBanner = "_2b-1";